
import { columnFormatters } from './formatters'
import _ from "lodash";

const columnComputations = {
  'MBKSExtCost': (product) => (identifyQuantity(product)* product['Cost']).toFixed(2),
  'MBKSExtRetail': (product) => (identifyQuantity(product) * product['TicketRetail']).toFixed(2),
  'MBKSMU': (product) => {
    if (product['TicketRetail']) {
      return (100 * (1 - (product['Cost'] / product['TicketRetail']))).toFixed(2)
    }
  },
  'SizeDetails': (product, state) => _.cond([
      [prod => {
        if (!prod.SizeGroupCode) return false;
        const current = _.chain(state).get("dynamicMutableObjectForDataTableEditors.sizegroups").find(a => _.eq(a.value, prod.SizeGroupCode)).value();
        if (!current) return true;

        if (_.eq(prod.EachesOrPacks, "eaches")) {
          return _.every(_.get(product, "SizeDetails"), s => _.find(_.flatten(current.sizes), {sizeNo: s.NrfSize}));
        } else {
          return _.every(_.chain(product).get("PackDetails").map("sizeScaleQtys").flatten().uniqBy("sizeNo").value(),
                  s => _.find(_.flatten(current.sizes), {sizeNo: s.sizeNo}));
        }
      }, p => _.get(p, "SizeDetails")],
      [_.stubTrue(), p => []]
  ])(product),
  'PackDetails': (product, state) => _.cond([
    [prod => {
      if (!prod.SizeGroupCode) return false;
      const current = _.chain(state).get("dynamicMutableObjectForDataTableEditors.sizegroups").find(a => _.eq(a.value, prod.SizeGroupCode)).value();
      if (!current) return true;

      if (_.eq(prod.EachesOrPacks, "packs")) {
        return _.every(_.chain(product).get("PackDetails").map("sizeScaleQtys").flatten().uniqBy("sizeNo").value(),
            s => _.find(_.flatten(current.sizes), {sizeNo: s.sizeNo}));
      }
    }, p => _.get(p, "PackDetails")],
    [_.stubTrue(), p => []]
  ])(product),

  'VendorUpc': (product, state) => _.cond([
      [prod => _.get(prod, "isVendorUpcMode"), p => _.get(p, "VendorUpc")],
      [_.stubTrue, p => /\d+/.test(_.get(p, "SizeGroupCode")) ? undefined : _.get(p, "VendorUpc")]
  ])(product)
};

const identifyQuantity = (product) => {
  if(product.hasOwnProperty('Quantity') && product['Quantity'] != 0) {
    return product['Quantity'];
  } else if(product.hasOwnProperty('PickedQty') && product['PickedQty'] != 0) {
    return product['PickedQty'];
  } else if(product.hasOwnProperty('AvailQty') && product['AvailQty'] != 0) {
    return product['AvailQty'];
  } else if(product.hasOwnProperty('PurchaseQty') && product['PurchaseQty'] != 0) {
    return product['PurchaseQty'];
  } else return 0;
}

export function updateComputedColumns(prod, state) {
  const product = { ...prod }
  const columnNames = Object.keys(columnComputations)
  const computed = columnNames.map((columnName) => {
    const computation = columnComputations[columnName]
    const result = computation(product, state)
    const formatter = columnFormatters[columnName]
    return formatter ? formatter(result) : result
  }).reduce((acc, computation, idx) => {
    acc[columnNames[idx]] = computation
    return acc
  }, {})

  return {
    ...product,
    ...computed,
  }
}

export function computeProductsSummary(products = []) {
  let summary
  const initialValues = {
    Quantity: 0,
    MBKSExtCost: 0,
    MBKSExtRetail: 0,
    MU: 0,
  }

  if (Array.isArray(products)) {
    summary = products.reduce((acc, prod) => {
      return {
        Quantity: acc.Quantity + _.toNumber(_.defaultTo(identifyQuantity(prod), 0)),
        MBKSExtCost: acc.MBKSExtCost + _.toNumber(_.defaultTo(prod.MBKSExtCost, 0)),
        MBKSExtRetail: acc.MBKSExtRetail + _.toNumber(_.defaultTo(prod.MBKSExtRetail, 0)),
      }
    }, initialValues)
  } else {
    summary = { ...initialValues }
  }

  summary.MU = 100 * (1 - (summary.MBKSExtCost / summary.MBKSExtRetail))

  return summary
}



// WEBPACK FOOTER //
// ./utilities/computations.js